import { getMediaCentricURI } from '@services/commonServices'
import { ImageAttributes, Modules, Operations } from '@modules/common'

export const getEnhancedImageURL = product => {
  let imageUrl = product?.['original-externalImages']?.img_Thumbnail
  if (!imageUrl) {
    const defaultImage = product?.['original-defaultImage-id']
    imageUrl = defaultImage
      ? getMediaCentricURI({
          URL: defaultImage,
          Attribute: ImageAttributes.SmallImage,
          Module: Modules.Publisher,
          Operation: Operations.GetFromNode
        })
      : null
  }
  return imageUrl
}
